import { SvgIcon, type SvgIconProps } from '@mui/material';

export const TikTok = (props: SvgIconProps) => (
  <SvgIcon viewBox="0 0 23 23" {...props}>
    <g transform="translate(4 3)">
      <path
        fill="currentColor"
        d="M11.304 0H8.271v12.26c0 1.462-1.167 2.662-2.619 2.662s-2.618-1.2-2.618-2.661c0-1.435 1.14-2.609 2.54-2.661V6.522C2.49 6.574 0 9.104 0 12.26 0 15.444 2.54 18 5.678 18s5.678-2.583 5.678-5.74V5.975a7.03 7.03 0 0 0 4.019 1.356V4.252c-2.282-.078-4.07-1.956-4.07-4.252"
      />
    </g>
  </SvgIcon>
);

export const DuneIcon = (props: SvgIconProps) => (
  <SvgIcon viewBox="0 0 24 24" {...props}>
    <g transform="translate(3 3)">
      <path
        d="M8.99998 18.0012C13.9705 18.0012 18 13.9718 18 9.00122C18 8.91852 17.9989 8.83607 17.9966 8.75391L1.57538 14.0895C3.19748 16.4519 5.91779 18.0012 8.99998 18.0012Z"
        fillOpacity="0.5"
        fill="currentColor"
      />
      <path
        d="M17.9998 9.06516C17.9999 9.04346 18 9.02174 18 9C18 4.02944 13.9706 0 9 0C4.02944 0 0 4.02944 0 9C0 10.8888 0.581847 12.6417 1.57608 14.0893L17.9966 8.75391C17.9989 8.83607 18 8.91852 18 9.00122C18 9.02255 17.9999 9.04387 17.9998 9.06516Z"
        fill="currentColor"
      />
    </g>
  </SvgIcon>
);
